import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Järelmaksu pakume püsiklientidele, &lt;a href="/login" class="text-on24-green font-bold"&gt;logi sisse&lt;/a&gt; või &lt;a href="/register" class="text-on24-green font-bold"&gt;liitu&lt;/a&gt;

  <span style="color:#85c1dc;">**FI:**</span>
  Tarjoamme osamaksua kanta-asiakkaille, &lt;a href="/login" class="text-on24-green font-bold"&gt;kirjaudu sisään&lt;/a&gt; tai &lt;a href="/register" class="text-on24-green font-bold"&gt;liity&lt;/a&gt;

  <span style="color:#85c1dc;">**RU:**</span>
  Предлагаем рассрочку постоянным клиентам, &lt;a href="/login" class="text-on24-green font-bold"&gt;авторизуйтесь&lt;/a&gt; или &lt;a href="/register" class="text-on24-green font-bold"&gt;присоединяйтесь&lt;/a&gt;
*/
/* @__NO_SIDE_EFFECTS__ */
const m1648 = msg(
  mf`Järelmaksu pakume püsiklientidele, <a href="/login" class="text-on24-green font-bold">logi sisse</a> või <a href="/register" class="text-on24-green font-bold">liitu</a>`,
  mf`Tarjoamme osamaksua kanta-asiakkaille, <a href="/login" class="text-on24-green font-bold">kirjaudu sisään</a> tai <a href="/register" class="text-on24-green font-bold">liity</a>`,
  mf`Предлагаем рассрочку постоянным клиентам, <a href="/login" class="text-on24-green font-bold">авторизуйтесь</a> или <a href="/register" class="text-on24-green font-bold">присоединяйтесь</a>`,
)

export { m1648 as 'w.toode.calculatorbody' }